import { FormLoader } from '@myosh/odin-components';
import clsx from 'clsx';

interface DataGridLoaderProps {
  isAllForms?: boolean;
  isCalendarView?: boolean;
}

export const DataGridLoader = ({ isAllForms = false, isCalendarView = false }: DataGridLoaderProps) => {
  const containerStyles = clsx('z-20 absolute h-full w-full bg-mono-1', { 'pl-10': !isAllForms && !isCalendarView });
  return (
    <div className={containerStyles}>
      <div className="h-14">
        <FormLoader width="xl" height="lg" />
      </div>
      <div className="pt-2">
        <FormLoader width="xl" height="md" />
        <FormLoader width="xl" height="md" />
        <FormLoader width="xl" height="md" />
      </div>
    </div>
  );
};
